import { createFileRoute } from '@tanstack/react-router'
import type { WesternSign } from '@mysterra/engine'

import { KnowledgeSignGrid } from '@/features/knowledge/components/knowledge-sign-grid'
import { useCopy } from '@/lib/copy/use-copy'
import { useKnowledge } from '@/lib/copy/use-knowledge'

const WESTERN_SIGNS: readonly WesternSign[] = [
  'aries',
  'taurus',
  'gemini',
  'cancer',
  'leo',
  'virgo',
  'libra',
  'scorpio',
  'sagittarius',
  'capricorn',
  'aquarius',
  'pisces',
]

export const Route = createFileRoute('/wiedza/zodiak')({
  component: WiedzaZodiak,
})

function WiedzaZodiak() {
  const { shell } = useCopy()
  const { data, isLoading, isError } = useKnowledge()
  const k = shell.knowledge

  const signs =
    data
      ? WESTERN_SIGNS.map((sign) => ({
          id: sign,
          sign,
          title: data.knowledge.zodiacSign[sign].label,
          keyword: data.knowledge.zodiacSign[sign].archetype,
          href: `/wiedza/zodiak/${sign}`,
        }))
      : []

  return (
    <section className="space-y-4 p-5">
      <a
        href="/wiedza"
        className="font-mono text-hint tracking-[1.3px] text-element-ink-mute uppercase"
      >
        &larr; {k.categoryBackLabel}
      </a>
      <div>
        <h1 className="font-display text-[28px] leading-[1.05] text-element-ink italic">
          {k.sectionZodiac}
        </h1>
        <p className="mt-1 text-hint text-element-ink-dim">
          {k.categoryZodiacCount} wpisów · {k.categoryZodiacHint}
        </p>
      </div>

      {isLoading && <p className="text-hint text-element-ink-dim">Ladowanie...</p>}
      {isError && (
        <p className="text-hint text-red-400">
          Nie udalo sie pobrac danych. Odswiez strone.
        </p>
      )}

      {data && <KnowledgeSignGrid signs={signs} />}
    </section>
  )
}
